export default __webpack_public_path__ + "static/media/icon-arrow-dropdown-bottom.ad69cb4e.svg";